module.exports = import("mfe-ccp2");;